module.exports = __webpack_public_path__ + "img/bannerBlue.a3e6a825.jpg";